module.exports = __webpack_public_path__ + "img/HQ-PA1W1T2RUH-V2-T.8e777b89.jpg";